export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Aviseringslogg";
};

export const detailUrl = ({ id }) =>
  `/rental-notifications/invoice-records/detail/${id}`;
